import React, { useEffect, useState } from "react";
import styles from "../TriggerField.module.scss";
import { TextField } from "@mui/material";
import { CustomDropdown } from "components/shared/customDropdown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems } from "redux/slices/triggerSlice";
import InputMask from 'react-input-mask'; // Importing the InputMask component
import { setPublish } from "redux/slices/globalSlice";
const optionsArray = [
    { label: "is", value: "is" },
    { label: "is not", value: "is not" },
    { label: "greater than", value: "greater than" },
    { label: "greater than or equal", value: "greater than or equal" },
    { label: "less than", value: "less than" },
    { label: "less than or equal", value: "less than or equal" },
    { label: "is between", value: "is between" },
    { label: "is not between", value: "is not between" },
    { label: "is answered", value: "is answered" },
    { label: "is unanswered", value: "is unanswered" },

];
const StopWatchTrigger = ({ item }) => {
    const { triggerDroppedList } = useSelector((state) => state?.trigger);
    const [localOptions, setLocalOptions] = useState(item?.trigger || { label: "Stopwatch", options: item?.operator || "is", value: item?.value || [], stopwatch1: item?.value[0], stopwatch2: item?.value[1] });

    const dispatch = useDispatch();

    const handleChange = (name, value) => {
        setLocalOptions((prev) => {
            let updatedOptions = { ...prev, [name]: value };

            if (name === "options") {
                if (value === "is between" || value === "is not between") {
                    updatedOptions = {
                        ...updatedOptions,
                        value: "",
                        stopwatch1: "",
                        stopwatch2: "",
                    };
                } else if (value === "is answered" || value === "is unanswered") {
                    updatedOptions = {
                        ...updatedOptions,
                        value: "",
                        stopwatch1: "",
                        stopwatch2: "",
                    };
                } else {
                    updatedOptions = {
                        ...updatedOptions,
                        stopwatch1: "",
                        stopwatch2: "",
                    };
                }
            }

            return updatedOptions;
        });
    };

    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id);
        dispatch(setDroppedItems(filteredDroppedItems));
        dispatch(setPublish(true))
    };

    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    optionLabel: item?.label || "Stopwatch", 
                    trigger: { ...localOptions },
                };
            }
            return e;
        });
        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);
    useEffect(() => {
        setLocalOptions((prev) => ({
            ...prev,
            options: item?.operator || prev.options,
            ...(item?.value?.[0] ? {
                stopwatch1: item?.value?.[0]
            } : {}),
            ...(item?.value?.[1] ? {
                stopwatch2: item?.value?.[1]
            } : {}),
            ...(item?.value ? {
                value: item?.value
            } : {}),
        }));
    }, [item?.operator, item?.value]);

    return (
        <div className={styles?.metaContainer}>
            <div className={styles?.field}>
                <TextField value={item?.label || "Stopwatch"} disabled name="label" />

                <CustomDropdown
                    width='200px'
                    name="options"
                    options={optionsArray}
                    value={localOptions?.options || ""}
                    onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                />
                {
                    localOptions?.options == "is between" || localOptions?.options == "is not between" ?

                        <>
                            <div style={{
                                display: "flex", alignItems: "center", gap: "10px"
                            }}>
                                <InputMask
                                    mask="99:99:99"
                                    value={localOptions?.stopwatch1 || "00:00:00"}
                                    onChange={(e) => handleChange('stopwatch1', e.target.value)}
                                    maskChar="0"
                                >
                                    {(inputProps) => (
                                        <TextField
                                            {...inputProps}
                                            placeholder="00:00:00"
                                        />
                                    )}
                                </InputMask>

                                <span style={{ fontWeight: "700" }}>And</span>
                                <InputMask
                                    mask="99:99:99"
                                    value={localOptions?.stopwatch2 || "00:00:00"}
                                    onChange={(e) => handleChange('stopwatch2', e.target.value)}
                                    maskChar="0"
                                >
                                    {(inputProps) => (
                                        <TextField
                                            {...inputProps}
                                            placeholder="00:00:00"
                                        />
                                    )}
                                </InputMask>
                            </div>
                        </>
                        :
                        localOptions?.options == "is answered" || localOptions?.options == "is unanswered" ? null :

                            <InputMask
                                mask="99:99:99"
                                value={localOptions?.value || "00:00:00"}
                                onChange={(e) => handleChange('value', e.target.value)}
                                maskChar="0"
                            >
                                {(inputProps) => (
                                    <TextField
                                        {...inputProps}
                                        placeholder="00:00:00"
                                    />
                                )}
                            </InputMask>

                }
            </div>


            <div
                style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                onClick={handleDelete}
            >
                <HighlightOffIcon />
            </div>
        </div>
    );
};

export default StopWatchTrigger;
